export default __webpack_public_path__ + "static/media/storageUnit1-afterA-1024w.d8c31fcd.avif";